<template>
  <div class="font-artlist">
    <MobileNav class="xl:hidden" />
    <DesktopNav class="hidden xl:block" />
  </div>
</template>

<script>
import MobileNav from './mobile'
import DesktopNav from './desktop'

export default {
  components: {
    MobileNav,
    DesktopNav,
  }
}
</script>

<style scoped>
.font-artlist {
  font-family: "Artlist Sans";
  line-height: 1.5;
  letter-spacing: 0.2px;
}
</style>
